module.exports = __webpack_public_path__ + "img/vlag-nl.681418a449c014d95d77476d411c9b27.svg";